import classNames from 'classnames';
import useGetWantedPhoneNumber from './hooks/useGetPhoneNumber';
import {useState} from 'react';
import Modal from 'components/modal';
import SendReplyMSG from 'components/modal/sendReplyMSG';

const Footer = ({
  hidePhoneNumber,
  guid,
  type,
  app,
  post_type,
}: ICardFooterProps) => {
  const [isSendMSGOpen, setIsSendMSGOpen] = useState<boolean>(false);
  const {isGetPhoneNumberLoading, refetch} = useGetWantedPhoneNumber(
    guid,
    type,
  );

  return (
    <div className="flex justify-between w-full ">
      <button
        className={classNames(
          ' bg-primary text-white py-4 text-center rounded-lg mx-0.5',
          !hidePhoneNumber ? 'w-1/2' : 'w-full',
        )}
        onClick={() => setIsSendMSGOpen(!isSendMSGOpen)}
      >
        <i className="icon-chat pe-1"></i>
        پیام به خریدار
      </button>
      {!hidePhoneNumber && (
        <button
          className=" bg-white border border-primary rounded-lg text-center w-1/2 text-primary mx-0.5 "
          onClick={() => {
            !isGetPhoneNumberLoading && refetch();
          }}
        >
          <i className="icon-phone-call pe-1"></i>
          تماس با خریدار
        </button>
      )}
      <Modal isOpen={isSendMSGOpen} setIsOpen={setIsSendMSGOpen}>
        <SendReplyMSG
          post={guid}
          profile_type={type}
          setIsOpen={setIsSendMSGOpen}
          post_type={post_type}
          buyers={true}
        />
      </Modal>
    </div>
  );
};

export default Footer;
